import { Data } from './Data';
import { Header } from './Header';

export const NameCell = { Data, Header };
